import { render, staticRenderFns } from "./cost_center.vue?vue&type=template&id=71db5394&scoped=true"
import script from "./cost_center.vue?vue&type=script&lang=js"
export * from "./cost_center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71db5394",
  null
  
)

export default component.exports